import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer, LoaderFunctionArgs } from 'react-router-dom'
import useStockStore from '../../store'
import { initialState } from './slice'
import { parseSortModelToParamString } from '$components/common'
import dayjs from 'dayjs'
import { getOldWorkflowRedirect } from '../helper'

export default async function loader({ request }: LoaderFunctionArgs) {
  const oldWorkflowRedirect = getOldWorkflowRedirect(
    '/stock/purchaseorder/history'
  )
  if (oldWorkflowRedirect) return oldWorkflowRedirect

  logger.debug(
    '[loader] About to await AppState being ready in Order History loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Order History loader')

  // Read URL search params for filters
  const url = new URL(request.url)
  const searchParams = url.searchParams

  const fromParam = searchParams.get('from')
  const toParam = searchParams.get('to')
  const referenceNumberParam = searchParams.get('referenceNumber')
  const supplierIdParam = searchParams.get('supplierId')

  // Reset the slice
  useStockStore.getState().resetPurchaseOrderHistorySlice()

  // Apply filters from URL params if they exist
  const filters = {
    from: fromParam
      ? dayjs(fromParam)
      : initialState.purchaseOrderHistoryFilters.from,
    to: toParam ? dayjs(toParam) : initialState.purchaseOrderHistoryFilters.to,
    referenceNumber: referenceNumberParam || '',
    supplierId: supplierIdParam || '',
  }

  // Update the store with the filters
  useStockStore.getState().purchaseOrderHistoryFilters = filters

  // Create a single promise that calls the API once
  const getPurchaseOrders = useStockStore
    .getState()
    .getPurchaseOrdersPaginated({
      start: filters.from,
      end: filters.to,
      referenceNumber: filters.referenceNumber,
      supplierName: filters.supplierId,
      page: useStockStore.getState().purchaseOrderPaginationModel.page,
      pageSize: useStockStore.getState().purchaseOrderPaginationModel.pageSize,
      sort: parseSortModelToParamString(
        useStockStore.getState().purchaseOrderSortModel
      ),
    })
  const getSuppliers = useStockStore.getState().getSuppliers()

  // Return a deferred promise to enable React Router's built-in loading state
  return defer({
    data: Promise.all([getPurchaseOrders, getSuppliers])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Order History error: ', error)
        return false
      }),
  })
}
